import React from 'react';
import { Box } from '@chakra-ui/react';
import { BusinessesContainer } from './containers/businesses';
import { ApiStatus } from './containers/apiStatus';
export var App = function () {
    return (React.createElement(Box, { mx: 48, my: 24 },
        React.createElement(ApiStatus, null),
        React.createElement(BusinessesContainer, null)));
};
